var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@tanstack/react-query';
import { HandshakePainterServiceApiV1 } from 'src/api/handshakeApi';
import { useAnalyticsContext } from 'src/common/metrics';
import { useDefaultApiParams } from './useDefaultApiParams';
/**
 * Fetches detail compliance data for a given ASIN.
 *
 * Uses `staleTime: Infinity` so that once data is fetched it is served from
 * cache on subsequent renders without triggering a network call. The cache is
 * cleared on route changes via `App.tsx`.
 *
 * Gate `enabled` on user interaction (e.g. sidesheet open) to defer the first
 * fetch until the data is actually needed.
 */
export const useProductComplianceDetailContent = ({ asin, enabled = true }) => {
    const defaultApiParams = useDefaultApiParams().getDefaultParams();
    const rumClient = useAnalyticsContext();
    return useQuery({
        queryKey: ['getProductComplianceDetail', asin],
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            const start = Date.now();
            try {
                const result = yield HandshakePainterServiceApiV1.getProductComplianceDetail({
                    asin: asin,
                    xUserLinked: defaultApiParams.xUserLinked,
                    xJoinId: defaultApiParams.xJoinId,
                    marketplaceId: defaultApiParams.marketplaceId,
                });
                rumClient.recordEvent('COMPLIANCE_DETAIL_CONTENT_API_LATENCY', {
                    asin,
                    durationMs: Date.now() - start,
                    status: 'success',
                });
                return result;
            }
            catch (e) {
                rumClient.recordEvent('COMPLIANCE_DETAIL_CONTENT_API_LATENCY', {
                    asin,
                    durationMs: Date.now() - start,
                    status: 'error',
                });
                const error = e;
                rumClient.recordEvent('COMPLIANCE_DETAIL_CONTENT_API_ERROR', {
                    asin,
                    errorTitle: error === null || error === void 0 ? void 0 : error.title,
                    errorDetails: (_a = error === null || error === void 0 ? void 0 : error.detail) !== null && _a !== void 0 ? _a : String(error),
                });
                throw e;
            }
        }),
        enabled: enabled && !!asin,
        staleTime: Infinity,
    });
};
